// payment_new
export default class PaymentInfo {
  constructor(args) {
    let form = document.getElementById("payment_form");
    let submitButton = document.getElementById("submitButton");

    form.addEventListener('submit', (e => {
      e.preventDefault();
      submitButton.classList.add('disabled');
      submitButton.disabled = true;
      submitForm().then(() => {
        console.log('done');
        submitButton.disabled = false;
        submitButton.classList.remove('disabled');
      }).catch(e => {
        console.log(e);
      })
    }), true);

    async function submitForm () {
      return new Promise(resolve => {
        form.submit();
        resolve()
      });
    }
  }
}



// WEBPACK FOOTER //
// ./pages/payment_confirm.js